<div class="c7-app-shell"><app-navbar></app-navbar><main class="main-panel"><div class="main-content-block"><div class="container-fluid"><router-outlet></router-outlet></div><app-footer></app-footer></div></main></div>
